import React, { Component } from 'react'
import { connect } from 'react-redux'
import { stripe } from '../actions/paymentActions'
import {Redirect, Link} from 'react-router-dom'
import StripeCheckout from 'react-stripe-checkout';
import stripeLogo from './assets/img/stripe.png'
import { config } from '../config'
import backto from './assets/img/backto.png'
import data from './assets/data'
import { importAll, isOdd } from '../utils/misc'
const nonprofitsImg = importAll(require.context('./assets/img/logos', false, /\.(png|jpe?g|svg)$/));

@connect((store)=>{
  return {
    paymentStripeProgress: store.payment.paymentStripeProgress,
    paymentStripeError: store.payment.paymentStripeError,
    paymentStripeSuccess: store.payment.paymentStripeSuccess,
  } 
})
class Donate extends Component {

  state = {
    amount: 10,
    pwtCount: 0
  }

  handleAmount = (e) => {
   this.setState({amount:e.target.value})
  }

  onToken = (token) => {
    let finalObject = {...token, amount: this.state.amount * 100, type: 'standalone' }
    this.props.dispatch(stripe(finalObject))
  }

  render() {

    let nonprofits = data.nonprofits.map((x,key) => {
      return (
      <div key={key} className="tileSmall flexChildSmall">
      <a href={x.url} rel="nofollow" target="_blank" className="img nonprofitsSmall">
      <img src={nonprofitsImg[x.logo]} alt={x.name}/></a></div>)
      })

    if(this.props.paymentStripeProgress){
      return (
      <section className="section-form color-1">
      <div className="loader"></div>
      </section>)
    }

    if(this.props.paymentStripeSuccess){
    return (
      <section className="section-form color-1">
      <h1 className="section-title">Thank you!</h1>
      <h3 style={{fontWeight: '400',fontSize: '18px',color: 'rgba(255, 255, 255, 0.59)'}} 
            className="section-subtitle">
            Your donation has been completed. You should receive the receipt on your e-mail.</h3> <br/>
            <a href="/" className="backto" ><img src={backto} width="300px" height="29px" /></a>
          
      </section>)
    }
    
    return (
      <section className="section-form color-1">
          <h1 className="section-title">Donate to charity!</h1>
          {this.props.paymentStripeError ? <p> Sorry, we had problems processing your payment!</p> : null}
          <h3 style={{fontWeight: '400',fontSize: '18px',color: 'rgba(255, 255, 255, 0.59)'}} 
            className="section-subtitle">All donation go towards an alliance of technology <strong>non-profits</strong>
            </h3>
      <div className="flexSmall">
        {nonprofits}
    </div>
          <h3 style={{fontWeight: '600',fontSize: '20px',color: 'rgba(255, 255, 255, 0.59)'}} 
            className="section-subtitle">Please select a donation method below:</h3><br/>
      
      <h3 className="donationsTitle"> U.S Dollar Donation </h3>
      <div style={{fontWeight: '400',fontSize: '14px',color: 'rgba(255, 255, 255, 0.2)',margin:'6px'}}>Amount ($)</div>
      <div className="form-amount"><input className="form-input amount-center" required type="number" min="1" step="any" onChange={this.handleAmount} defaultValue={10.00}/></div>
      <StripeCheckout token={this.onToken} image={stripeLogo} 
      amount={this.state.amount*100} name="hack.summit() 2018" token={this.onToken} stripeKey={config.stripeKey}>
      <button className="btn-register btn btn-primary">Donate</button></StripeCheckout>
      
      <hr className="style1"/>
      <h3 className="donationsTitle"> Cryptocurrency Donation </h3>
      <div style={{fontWeight: '400',fontSize: '14px',color: 'rgba(255, 255, 255, 0.5)',margin:'6px'}}>
      </div>
      <a href="https://commerce.coinbase.com/checkout/6f192892-d036-4830-9249-90f2659fd09a" target="_blank">
      <button type="submit" className="btn-register btn btn-primary">Donate</button></a><br/>
      <div>
      </div>
      </section>
    );
  }
}

export default Donate;



// WEBPACK FOOTER //
// ./src/components/Donate.js